import { useState } from 'react';

import { Form } from '../../Form';
import type { FormProps } from '../../Form';
import { InputLabelContext } from '../../shared/InputLabelContext';
import { LayoutContext } from './LayoutContext';

export type FormLayoutProviderProps = FormProps & {
  /**
   * If the form only contains a single question, you can pass the id of the
   * input here and it will use the form's Title component as the input's
   * label. You can then pass an empty string as the title prop for the input
   * (if you try to pass an empty string without using this prop, it will
   * throw an error).
   */
  singleQuestionInputId?: string;
};

/**
 * Top-level provider that wraps all form page components.
 */
export const FormLayoutProvider = ({
  children,
  singleQuestionInputId,
  ...props
}: FormLayoutProviderProps) => {
  const [bottomNavHeight, setBottomNavHeight] = useState<number>();

  return (
    <Form {...props}>
      <LayoutContext.Provider value={{ bottomNavHeight, setBottomNavHeight }}>
        <InputLabelContext.Provider value={{ inputId: singleQuestionInputId }}>
          {children}
        </InputLabelContext.Provider>
      </LayoutContext.Provider>
    </Form>
  );
};
